import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { PermissionDirective } from '@common/directives/permission.directive';
import { AuthService } from '@infra/auth/auth.service';
import { Globals } from '@system/globals';

@Component({
  selector: 'app-search-bar-get-started',
  templateUrl: './search-bar-get-started.component.html',
  imports: [RouterLink, PermissionDirective, TranslatePipe],
})
export class SearchBarGetStartedComponent {
  readonly authService = inject(AuthService);

  globals = Globals;
}
